import React from "react";
import PropTypes from "prop-types";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
  }  

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6">
          <div className="max-w-xl w-full bg-white shadow-md rounded-md p-6">
            <h2 className="text-xl font-semibold mb-2">Something went wrong.</h2>
            <p className="text-sm text-gray-600 mb-4">
              An unexpected error occurred. You can try to reload the page or contact support.
            </p>

            {process.env.NODE_ENV === "development" && (
              <details className="mb-4 whitespace-pre-wrap text-xs text-red-600">
                {String(this.state.error) + "\n"}
                {this.state.errorInfo?.componentStack}
              </details>
            )}

            <div className="flex gap-2">
              <button
                onClick={() => window.location.reload()}
                className="px-4 py-2 rounded bg-teal-600 text-white hover:bg-teal-700"
              >
                Reload
              </button>
              <button
                className="px-4 py-2 rounded border border-gray-300 hover:bg-gray-50"
              >
                <a href="/">Back to Homepage</a>
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};